$('.js-home-slick').slick({
  slidesToShow: 1,
  autoplay: true,
  speed: 3000,
  fade: true,
  dots: true,
  arrows: false,
  waitForAnimate: false,
});

$(window).on('load',function(){
  setTimeout(function(){
    $('.js-bnr-move').addClass('is_move');
    setTimeout(function(){
      $('.js-bnr-open').addClass('is_open');
    }, 1000);
  }, 500);
});

$(window).on('load scroll', function (){
  $('.js-fade').each(function(){
    var pos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > pos - windowHeight + 100){
      $(this).addClass('scroll');
    } else {
      $(this).removeClass('scroll');
    }
  });
});
